<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M14.28 27.53c-6.42.03-11.704-5.137-11.704-11.43 0-6.877 5.284-11.634 11.704-11.633h3.01C23.633 4.465 29.424 9.22 29.424 16.1c0 6.29-5.79 11.432-12.134 11.432h-3.01zm-.008-22.1C8.415 5.43 3.67 10.139 3.67 15.95c0 5.81 4.746 10.519 10.603 10.52 5.858 0 10.605-4.71 10.607-10.52-.002-5.812-4.75-10.52-10.607-10.522zm-2.41 4.378V22.26c-2.524-.961-4.315-3.384-4.321-6.225.006-2.842 1.796-5.263 4.32-6.227zm4.82-.001c2.527.96 4.32 3.385 4.325 6.228-.005 2.844-1.798 5.266-4.325 6.228V9.806z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandDinersClub'
}
</script>
